export const images = {
  loginBackground: require('assets/img/login-background.jpg'),
  avatar: require('assets/img/avatar.png'),
  logo: require('assets/img/logo.png')
};
